import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
  Grid,
  GridItem,
} from "@chakra-ui/react";

import {
  CompletedIcon,
  IncomingIcon,
  PendingIcon,
  RejectedIcon,
} from "../../assets/svgs/Icons";
import { IncomingProcurements } from "./IncomingProcurements";
import { AcceptedProcurements } from "./AcceptedProcurements";
import { RejectedProcurements } from "./RejectedProcurements";
import { useDispatch, useSelector } from "react-redux";
import { getCountsForProcurements } from "./ProcurementApprovalSlice";
import isAllowed from "../../routing/isAllowed";

const ProcurementApproval = () => {
  const [page, setPage] = useState(0);
  const [status, setStatus] = useState("idle");
  const dispatch = useDispatch();
  const { counts } = useSelector((state) => state.procurementApproval);
  const [isActive, setIsActive] = useState(0);

  const STEP_PAGES = [
    {
      id: 0,
      component: () => <IncomingProcurements />,
    },
    {
      id: 1,
      component: () => <AcceptedProcurements />,
    },
    {
      id: 2,
      component: () => <RejectedProcurements />,
    },
    // {
    //   id: 3,
    //   component: () => <CertifierRejectedApplications />,
    // },
  ];

  const getCounts = () => {
    try {
      setStatus("pending");
      dispatch(getCountsForProcurements());
      setStatus("success");
    } catch (error) {
      setStatus("rejected");
      console.error(error);
    }
  };

  const handleTabClick = (tabIndex) => {
    setPage(tabIndex);
    // Updates localStorage with new active tab index
    localStorage.setItem("activeTab", tabIndex);
  };

  useEffect(() => {
    let storedActiveTab = localStorage.getItem("activeTab") || 0;
    if (storedActiveTab > STEP_PAGES.length - 1) {
      storedActiveTab = 0;
    }
    setPage(parseInt(storedActiveTab));
    setIsActive(parseInt(storedActiveTab));
  }, [page, isActive]);

  useEffect(() => {
    getCounts();
  }, []);

  return (
    <Box>
      <Box bg="#EDF3F8" marginTop="2rem" borderRadius={"15px"}>
        <Grid
          width={"100%"}
          templateColumns="repeat(4, 1fr)"
          my={"1rem"}
          gap="1rem"
          height={"100%"}
        >
          <GridItem>
            <Box
              bg={isActive === 0 ? "#fff" : "#D4EEFF"}
              color="#000000"
              width={"289px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              boxShadow={
                isActive === 0
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              textAlign={"center"}
              onClick={() => {
                handleTabClick(0);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <IncomingIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {counts?.["INCOMING"]?.count || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Incoming Applications
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 1 ? "#fff" : "#52C4FF"}
              color="#141D43
                          "
              width={"289px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              boxShadow={
                isActive === 1
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(1);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <CompletedIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {counts?.["APPROVE"]?.count || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Accepted Applications
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 2 ? "#fff" : "#FE96A6"}
              color="#141D43
                          "
              width={"289px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              boxShadow={
                isActive === 2
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(2);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <RejectedIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {counts?.["REJECT"]?.count || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Rejected Applications
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
        </Grid>
      </Box>
      {STEP_PAGES[page]?.component()}
    </Box>
  );
};

export default isAllowed(ProcurementApproval);
